// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29-Rh","clinicsSelect":"styles_clinicsSelect__-OXdw"};